import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import { useNavigate, useParams } from "react-router";
import { loader } from "../../store/utilities";
import {getCategoryProgrammeById } from "../../Api/commonApi";
import { SearchInput } from "../../components/SearchInput";


const ProgrammeList = () => {
  const [allCategoryInfo, setAllCategoryInfo] = useState([]);
  const [getAllData, setGetAllData] = useState([]);
  const navigate = useNavigate();

  const {id} = useParams()

  const getAllDataFunction = async () => {
    loader.start();
    try {
      let response = await getCategoryProgrammeById(id).then((res) => res.data.data);
      setGetAllData(response);
      setAllCategoryInfo(response)
    } catch (err) {
      console.error("Error fetching data", err);
    } finally {
      loader.stop();
    }
  };

  useEffect(() => {
    getAllDataFunction();
  }, []);

  // Filtered data based on search term
 
  const searchInfoList = (text) => {
    if (text.toLowerCase().trim().length !== 0) {
      const filteredInfo = allCategoryInfo.filter((res) => {
        return (
          res.name?.toLowerCase()?.includes(text)
         
        );
      });
      setGetAllData(filteredInfo);
      
    } else {
      setGetAllData(allCategoryInfo);
    }
  };

  return (
    <div className="mainContainer">
         <div className="d-flex justify-content-between">
           <div className={style.heading_section_programme}>Programme List</div>
           <div>
             <SearchInput onChange={(e) => searchInfoList(e.target.value)} />
           </div>
         </div>
   
         <div className={`${style.card_container} mt-5`}>
         {getAllData.map((data, index) => (
             <div
               key={index}
               className={`${style.card_style} `}
               onClick={() => {
                 navigate(`/programmedetail/${data._id}`);
               }}
             >
               <div>
                 <img
                   src={data?.logo?.fileUrl}
                   alt={data.title}
                   width={100}
                   height={100}
                 />
               </div>
               <div className="category_name_style">{data.name}</div>
             </div>
           ))}
         </div>
       </div>
  );
};

export default ProgrammeList;
